<template>
  <el-form ref="AccountFrom" :model="account" :rules="rules" label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h3 class="title">{{copyright}}设备管理后台</h3>
    <el-form-item prop="username">
      <el-input type="text" v-model="account.username" auto-complete="on" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="pwd">
      <el-input type="password" v-model="account.pwd" auto-complete="on" placeholder="密码" @keyup.enter.native="handleLogin"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleLogin" :loading="logining">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import md5 from 'js-md5'
  import $ajax from '../https/config'
  import {getQueryString, isNull} from '../js/tool'
  import {getCopyRight} from '../../static/copyright'
  export default {
    data () {
      return {
        logining: false,
        account: {
          username: '',
          pwd: ''
        },
        rules: {
          username: [
            {required: true, message: '请输入账号', trigger: 'blur'}
          ],
          pwd: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ]
        },
        checked: true,
        copyright:''
      }
    },
    created: function () {
      this.EnterNextBack()
      this.copyright = getCopyRight()
    },
    methods: {
      handleLogin () {
        this.$refs.AccountFrom.validate((valid) => {
          if (valid) {
            var loginParams = {phoneNumber: this.account.username, password: md5(this.account.pwd)}
            this.ajaxLogin(loginParams)
          }
        })
      },
      ajaxLogin (loginParams) {
        this.logining = true
        var _this = this
        var url = '/custom/login'
        $ajax.get(url, loginParams, '', function (res) {
          _this.logining = false
          if (res.resultStatus) {
            if (res.resultData.user_type === 3 || res.resultData.user_type === 5) {
              _this.$message({
            type: 'error',
            duration: 1000 * 5,
            message: '非代理、设备主、商户不能登录设备管理后台,权限不足！'
          })
              return
            }
            sessionStorage.setItem('lbz-device-user-info', JSON.stringify(res.resultData))
            _this.$store.commit('setAccessToken', res.resultData.user_token)
            _this.$store.commit('setUserType', res.resultData.user_type)
            _this.$router.push({ path: '/' })
          } else {
            _this.$message({
              message: res.errorMessage,
              type: 'error'
            })
          }
        }, function (err) {
          _this.logining = false
          _this.$message({
            type: 'error',
            duration: 1000 * 5,
            message: '服务器异常，请稍后再试!' + err
          })
        })
      },
      EnterNextBack () {
        if (!isNull(getQueryString('user'))) {
          this.account.username = getQueryString('user')
          this.account.pwd = getQueryString('pwd')
          var loginParams = {phoneNumber: this.account.username, password: this.account.pwd}
          this.ajaxLogin(loginParams)
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
     -webkit-border-radius: 5px;
    border-radius: 5px;
     -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 160px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    background: -ms-linear-gradient(top, #fff, #6495ed);        /* IE 10 */
    background:-moz-linear-gradient(top,#b8c4cb,#f6f6f8);/*火狐*/
    background:-webkit-gradient(linear, 0% 0%, 0% 100%,from(#b8c4cb), to(#f6f6f8));/*谷歌*/
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#fff), to(#6495ed));      /* Safari 4-5, Chrome 1-9*/
    background: -webkit-linear-gradient(top, #fff, #6495ed,#fff);   /*Safari5.1 Chrome 10+*/
    background: -o-linear-gradient(top, #fff, #6495ed);  /*Opera 11.10+*/

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/login.vue